import React, { Component } from "react";
import { useEffect } from "react";
import api from "../api";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import "../Styles/Home.css";
import { Link } from "react-router-dom";
import Navbar from "../Components/Core/Navbar.jsx";
import Footer from "../Components/Core/Footer.jsx";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/bundle";
import { FaRegHeart } from "react-icons/fa";
import UniversalCard from "../Components/UniversalCard.jsx";
import PopularProoducts from "../HomeComponents/PopularProoducts.jsx";
import ProductBox from "../HomeComponents/ProductBox.jsx";
import Deal from "../HomeComponents/Deal.jsx";
import Skeleton from "react-loading-skeleton";
import ScrollToTopButton from "../Components/ScrollToTopButton.jsx";
import "react-loading-skeleton/dist/skeleton.css";

const Home = () => {
  const [sliderImage, setSliderImage] = React.useState([]);
  const [newArrival, setnewArrival] = React.useState([]);
  const accessToken = localStorage.getItem("accessToken");
  const [bannerList, setBannerList] = React.useState([]);
  const [best_seller, setBest_seller] = React.useState([]);
  const [cardImage, setCardImage] = React.useState([]);
  const [category, setCategory] = React.useState([]);
  const [store, setStore] = React.useState([]);
  const [popularProducts, setPopularProducts] = React.useState([]);
  const [dealsProduct, setDealsProduct] = React.useState([]);
  const [laptops, setLaptops] = React.useState([]);
    const [fadeBanner, setFadeBanner] = React.useState([]);
  const [iPhones, setIPhones] = React.useState([]);
  const [sliderList, setSliderList] = React.useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(true);
  const [isMobileScreen, setIsMobileScreen] = React.useState(
    window.innerWidth < 768
  );

  useEffect(() => {
    if (sliderImage.length > 0) {
      setLoading(false);
    }
    if (category.length > 0) {
      setLoading(false);
    }
    if (store.length > 0) {
      setLoading(false);
    }
  }, [sliderImage, category, store]);

    const fetchFadeBannerList = async () => {
    const res = await api.get("/user_api/advertise/get-advertise-images-for-web");
    console.log("fetchFadeBannerList : ", res);
    if (res.data.status === "success") {
      setFadeBanner(res.data.images_list)
    }
  };

  const fetchBannerList = async () => {
    const res = await api.get("/user_api/banners/get-banner-list");
    console.log("get-banner-list : ", res);
    if (res.data.status === "success") {
      setBannerList(res.data.banner_list);
      console.log("banner list", res.data.banner_list);
    }
  };

  const fetchNewArrivals = async () => {
    const res2 = await api.get(
      `/user_api/product/new-arrivals?access_token=${JSON.parse(accessToken)}`
    );
    setnewArrival(res2.data.product_list);
  };

  const fetchSliderList = async () => {
    const res = await api.get("/user_api/slider/get-slider-list-for-web");
    setSliderImage(res.data.slider_list);
    setSliderList(res.data.slider_list);
  };

  const fetchAllProducts = async () => {
    const res = await api.get(
      `/user_api/product/get-all-product-list?access_token=${JSON.parse(
        accessToken
      )}`
    );
    setCardImage(res.data.product_list);
    const res2 = await api.get(
      `/user_api/product/new-arrivals?access_token=${JSON.parse(accessToken)}`
    );
    setnewArrival(res2.data.product_list);
    const res3 = await api.get(
      `/user_api/product/best-seller-list?access_token=${JSON.parse(
        accessToken
      )}`
    );
    setBest_seller(res3.data.product_list);
    const res4 = await api.get("/user_api/product/flash-deals");
    setDealsProduct(res4.data.product_list);
  };

  const fetchBestSellers = async () => {
    const res3 = await api.get(
      `/user_api/product/best-seller-list?access_token=${JSON.parse(
        accessToken
      )}`
    );
    setBest_seller(res3.data.product_list);
  };

  const fetchCategories = async () => {
    const res = await api.get("/user_api/category/get-category-list");
    setCategory(res.data.category_list);
  };

  const fetchSubCategories = async () => {
    const res = await api.get("/user_api/category/get-all-subcategory");
    setStore(res.data.subcategory_list);
  };

  const fetchTrending = async () => {
    const res = await api.get(
      `/user_api/product/trending-list??access_token=${JSON.parse(accessToken)}`
    );
    setPopularProducts(res.data.product_list);
  };

  const fetchFlashDeals = async () => {
    const res4 = await api.get("/user_api/product/flash-deals");
    setDealsProduct(res4.data.product_list);
  };

  const fetchLaptops = async () => {
    const res = await api.get(
      `user_api/product/get-product-list-by-subcategory?slug=Laptop`
    );
    setLaptops(res.data.product_list);
  };

  const fetchIPhones = async () => {
    const res = await api.get(
      `user_api/product/get-product-list-by-subcategory?slug=iPhone`
    );
    setIPhones(res.data.product_list);
  };

  const loadAllData = async () => {
    try {
      await Promise.all([
        fetchFadeBannerList(),
        fetchBannerList(),
        fetchNewArrivals(),
        fetchSliderList(),
        fetchAllProducts(),
        fetchBestSellers(),
        fetchCategories(),
        fetchSubCategories(),
        fetchTrending(),
        fetchFlashDeals(),
        fetchLaptops(),
        fetchIPhones(),
      ]);
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };
  useEffect(() => {
    loadAllData();
  }, []);

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          position: "absolute",
          backgroundColor: "rgba(0, 0, 0, 0.29)",
          height: "auto",
          padding: "3px",
          width: "26px",
          borderRadius: "10px 50px 50px 10px",
        }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          position: "absolute",
          backgroundColor: "rgba(0, 0, 0, 0.29)",
          height: "auto",
          padding: "3px",
          width: "26px",
          borderRadius: "50px 10px 10px 50px",
        }}
        onClick={onClick}
      />
    );
  }

  const settings2 = {
    infinite: true,
    speed: 1500,
    centerMode: true, // IMPORTANT: Centers the active slide
    centerPadding: "65px", // Show partial previous/next slides
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1424,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "25px",
        },
      },
    ],
  };

  const settings3 = {
     infinite: true,
    speed: 800,
    slidesToShow: 8,
    slidesToScroll: 1,
    arrows: true,

    // nextArrow: <SampleNextArrow />,
    // prevArrow: <SamplePrevArrow />,

     autoplay: true,
    autoplaySpeed: 5000,

    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 8,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 7,
        },
      },
      {
        breakpoint: 1060,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 940,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 780,
        settings: {
          slidesToShow: 4,
        },
      },

      {
        breakpoint: 680,
        settings: {
          slidesToShow: 3.5,
        },
      },

      {
        breakpoint: 566,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 460,
        settings: {
          slidesToShow: 2.5,
        },
      },
    ],
  };

  return (
    <div id="wb-container" className="wb-effect10">
      <Navbar />
      <div>
        <div
          className="category-container-items"
          style={{
            maxWidth: "100%",
            overflowX: "auto",
            flexWrap: "nowrap",
            gap: "10px",
            minWidth: "100%",
            padding: " 8px",
          }}
        >
          {loading
            ? Array.from({ length: 6 }).map((_, index) => (
                <div
                  key={index}
                  className="category-box"
                  style={{ alignItems: "center" }}
                >
                  <Skeleton circle={true} height={55} width={55} />
                  <Skeleton width={80} height={15} style={{ marginTop: 8 }} />
                </div>
              ))
            : category.map((cat, index) => (
                <Link
                  to={`/category/${cat.slug}`}
                  key={index}
                  className="category-box"
                  style={{ alignItems: "center", minWidth: "80px" }}
                >
                  <img
                    src={`${cat.category_image_path[0]}`}
                    alt={cat.category_name}
                    width="55"
                  />
                  <span style={{ color: "black" }}>{cat.category_name}</span>
                </Link>
              ))}
        </div>
      </div>

      <div data-content-region="header_bottom--global" />
      <div data-content-region="header_bottom" />
      <div data-content-region="home_below_menu" />

      <div className="slider-container1">
        <Slider {...settings2}>
          {loading
            ? Array.from({ length: 3 }).map((_, index) => (
                <div className="slider-item" key={index}>
                  <Skeleton height={300} width="100%" />
                  <div className="slider-caption">
                    <Skeleton width={`80%`} height={20} />
                  </div>
                </div>
              ))
            : sliderImage.map((item, index) => (
                <div
                  className="slider-item1"
                  key={index}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    window.open(`${sliderList[index].product_url}`, "_blank");
                    console.log("click", sliderList[index]);
                  }}
                >
                  {
                    <img
                      src={item.slider_image_path}
                      alt={`slider-${item.id}`}
                      className="slider-image2"
                      style={{ borderRadius: "20px" }}
                    />
                  }
                  {item.description && (
                    <div>
                      <p style={{ fontSize: "40px" }}>{item.description}</p>
                    </div>
                  )}
                </div>
              ))}
        </Slider>
      </div>

      <main
        className="body"
        id="main-content"
        role="main"
        data-currency-code="USD"
      >
        <div className="main full">
          <div data-content-region="home_below_featured_products" />
        </div>

        {/* Eesouq Store */}

        <div
          style={{
            width: "100%",
            // background: "linear-gradient(180deg,#ffd6cc,white)",
            backgroundColor: "#d7f9ab",
          }}
        >
          <div style={{ width: "95%", margin: "auto" }}>
            <h2
              className="section-title section-title1"
              style={{
                fontSize: "2.5vw",
                fontWeight: "900",
                paddingTop: "30px",
              }}
            >
              EESOUQ <span className="title-highlight">STORE</span>
            </h2>

            <div className="product-slider">
              <Slider {...settings3}>
                {loading
                  ? Array.from({ length: 6 }).map((_, index) => (
                      <div
                        key={index}
                        style={{
                          flexDirection: "column",
                          height: "auto",
                          backgroundColor: "red",
                        }}
                        className="store-card"
                      >
                        <div className="product-image-container">
                          <Skeleton height={120} width="100%" />
                        </div>

                        <div
                          className="product-info1"
                          style={{ padding: "0px" }}
                        >
                          <h4
                            className="product-name"
                            style={{ textAlign: "center" }}
                          >
                            <Skeleton width="60%" height={20} />
                          </h4>
                        </div>
                      </div>
                    ))
                  : store.map((product) => (
                      <div
                        key={product.id}
                        onClick={() =>
                          navigate(`/subcategory/${product.sub_category_name}`)
                        }
                        style={{
                          padding: "20px",
                          flexDirection: "column",
                          height: "auto",
                          background: "linear-gradient(180deg,white,#f8e996)",

                          position: "relative",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "20px",
                          borderRadius: "10px",
                          border: "1px solid #e0e0e0",
                          marginLeft: "10px",
                          marginRight: "10px",
                          marginBottom: "20px",
                          backgroundImage:
                            "linear-gradient(180deg, rgb(245, 243, 136), white)",
                        }}
                        className="product-card-item1"
                      >
                        <div className="product-image-wrapper1">
                          <img
                            src={product.subcategory_image_path}
                            alt={product.product_name}
                            className="product-card-image hover-zoom"
                            loading="lazy"
                          />
                        </div>

                        <div
                          className="product-info2"
                          style={{
                            padding: "0px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <h4
                            className="product-name1"
                            style={{ textAlign: "center" }}
                          >
                            {product.sub_category_name}
                          </h4>
                        </div>
                      </div>
                    ))}
              </Slider>
            </div>
          </div>
        </div>

        {/* iPhones       */}
        <div
          style={{
            width: "100%",
            background: "linear-gradient(180deg,white,#ffe6ff)",
          }}
        >
          <div style={{ width: "95%", margin: "auto" }}>
            <h2
              className="section-title section-title1"
              style={{
                fontSize: "2.5vw",
                fontWeight: "900",
                paddingTop: "20px",
              }}
            >
              Latest <span className="title-highlight d-flex">iPhones</span>
            </h2>

            <ProductBox
              url={`user_api/product/get-product-list-by-subcategory?slug=Iphone`}
            />
          </div>
        </div>

        {/* Fade Banner */}

        <div className="banner-wrapper fade-in-slide">
          <a target="_blank" rel="noopener noreferrer" className="banner-link">
            <img
              // src="https://images-static.nykaa.com/uploads/d3d31cac-351c-4498-a097-cd374042b298.jpg?tr=cm-pad_resize,w-1200"
              src={fadeBanner[0]?.advertise_image_path}
              alt="Best of Beauty Banner"
              className="banner-image"
              loading="lazy"
            />
          </a>
        </div>

        {/* Laptops */}

        <div
          style={{
            width: "100%",
            background: "linear-gradient(0deg,#ffffb3,white,white)",
            paddingBottom: "5px",
          }}
        >
          {/* <UniversalCard Heading={"LAPTOPS"} CardData={laptops}/> */}
          <div style={{ width: "95%", margin: "auto" }}>
            <h2
              className="section-title section-title1"
              style={{
                fontSize: "2.5vw",
                fontWeight: "900",
                paddingTop: "20px",
              }}
            >
              Trending in<span className="title-highlight d-flex">Laptops</span>
            </h2>

            <ProductBox
              url={`/user_api/product/get-product-list-by-subcategory?slug=Laptop&&access_token=${JSON.parse(
                accessToken
              )}`}
            />
          </div>
        </div>

        <UniversalCard
          Heading={"NEW ARRIVAL"}
          CardData={newArrival}
          refreshCardData={fetchAllProducts}
        />

        {
          <div
            className="css-1hqhe e150ol5z14  homeBanner"
            style={{ paddingTop: "-10px" }}
          >
            <div
              id="67ffaf7d039600a88a62311f"
              className="css-1eawp00 e150ol5z0"
            >
              <div className="snaptogrid">
                <div
                  className="67ffaf7d039600a88a62311f css-hcnnf9 e150ol5z4"
                  style={{
                    transition: "transform 0.5s ease",
                    transform: "translateX(0px)",
                  }}
                >
                  <div style={{ display: "inherit" }}>
                    <div style={{ display: "inherit" }}>
                      <div
                        id="67ffaf7d039600a88a623120"
                        className="banner-container css-yvpisj"
                      >
                        <div className="css-uhwoxe">
                          <div className="image-tag-wrapper">
                            <div className="image-container">
                              <div className="card-view banner-rotator" />
                              <div className="image-with-logo flip-container">
                                <div
                                  className="image-wrapper css-ugtohg ean6s9n1 flipper"
                                  id="67ffb003728ef523f3096981"
                                >
                                  <div
                                    className="img-wrap front"
                                    style={{
                                      margin: "25px 0px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <a
                                      target="_blank"
                                      aria-label="DN_BANNER_IMAGE"
                                      className="css-13o7eu2 etj7ng30"
                                    >
                                      <img
                                        // src="https://images-static.nykaa.com/uploads/939b2174-140b-433d-8982-1098fc118342.jpg?tr=cm-pad_resize,w-1200"
                                        src={fadeBanner[1]?.advertise_image_path}
                                        alt="hdfc_bank_strip"
                                        loading="eager"
                                        //srcSet="https://images-static.nykaa.com/uploads/939b2174-140b-433d-8982-1098fc118342.jpg?tr=cm-pad_resize,w-1200 1x, https://images-static.nykaa.com/uploads/939b2174-140b-433d-8982-1098fc118342.jpg?tr=cm-pad_resize,w-1800 1.5x"
                                     srcSet={fadeBanner[1]?.advertise_image_path}
                                     />
                                    </a>
                                  </div>
                                  <div
                                    className="img-wrap back"
                                    style={{
                                      margin: "25px 0px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <a
                                      target="_blank"
                                      aria-label="DN_BANNER_IMAGE"
                                      className="css-13o7eu2 etj7ng30"
                                    >
                                      <img
                                        // src="https://images-static.nykaa.com/uploads/939b2174-140b-433d-8982-1098fc118342.jpg?tr=cm-pad_resize,w-1200"
                                       src={fadeBanner[1]?.advertise_image_path}
                                        alt="hdfc_bank_strip"
                                        loading="eager"
                                       // srcSet="https://images-static.nykaa.com/uploads/939b2174-140b-433d-8982-1098fc118342.jpg?tr=cm-pad_resize,w-1200 1x, https://images-static.nykaa.com/uploads/939b2174-140b-433d-8982-1098fc118342.jpg?tr=cm-pad_resize,w-1800 1.5x"
                                      srcSet={fadeBanner[1]?.advertise_image_path}
                                      />
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className=" tag-text-wrapper " />
                            <div className="outline-wrapper" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        {/* Recommanded for you */}

        <UniversalCard
          Heading={"RECOMMANDED FOR YOU"}
          CardData={cardImage}
          refreshCardData={fetchAllProducts}
        />

        {/* Deals of the Day */}

        <Deal
          Heading={"DEALS OF THE DAY"}
          CardData={dealsProduct}
          refreshCardData={fetchAllProducts}
          wishlist={"0"}
        />

        {/* Web Features Section */}
        <div className="wb-section wb-section--section1 mt-4 banner-figures-container">
          <div className="container">
            <div className="module-wrapper staticBanner staticBanner--services   wow fadeIn">
              <div className="block-content clearfix d-flex flex-row">
                <div className="banner-figures">
                  <a
                    href="#"
                    className="icon banner-figure"
                    aria-label="carousel.arrowAriaLabel "
                  >
                    {/* To insert the icon: */}
                    <span className="lnr lnr-rocket" />
                  </a>
                  <div className="banner-figcaption">
                    <div className="banner-figcaption__body">
                      <h5 className="banner-figcaption__title">
                        <a href="#">Free Shipping</a>
                      </h5>
                      <div className="banner-figcaption__text">
                        Free Shipping On All Order
                      </div>
                    </div>
                  </div>
                </div>
                <div className="banner-figures">
                  <a
                    href="#"
                    className="icon banner-figure"
                    aria-label="carousel.arrowAriaLabel "
                  >
                    {/* To insert the icon: */}
                    <span className="lnr lnr-sync" />
                  </a>
                  <div className="banner-figcaption">
                    <div className="banner-figcaption__body">
                      <h5 className="banner-figcaption__title">
                        <a href="#">Money Guarantee</a>
                      </h5>
                      <div className="banner-figcaption__text">
                        30 Day Money Back Guarantee
                      </div>
                    </div>
                  </div>
                </div>
                <div className="banner-figures">
                  <a
                    href="#"
                    className="icon banner-figure"
                    aria-label="carousel.arrowAriaLabel "
                  >
                    {/* To insert the icon: */}
                    <span className="lnr lnr-users" />
                  </a>
                  <div className="banner-figcaption">
                    <div className="banner-figcaption__body">
                      <h5 className="banner-figcaption__title">
                        <a href="#">Online Support 24/7</a>
                      </h5>
                      <div className="banner-figcaption__text">
                        Technical Support 24/7{" "}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="banner-figures">
                  <a
                    href="#"
                    className="icon banner-figure"
                    aria-label="carousel.arrowAriaLabel "
                  >
                    {/* To insert the icon: */}
                    <span className="lnr lnr-thumbs-up" />
                  </a>
                  <div className="banner-figcaption">
                    <div className="banner-figcaption__body">
                      <h5 className="banner-figcaption__title">
                        <a href="#">Member Discount</a>
                      </h5>
                      <div className="banner-figcaption__text">
                        Upto 40% Discount All Products{" "}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="banner-figures">
                  <a
                    href="#"
                    className="icon banner-figure"
                    aria-label="carousel.arrowAriaLabel "
                  >
                    {/* To insert the icon: */}
                    <span className="lnr lnr-license" />
                  </a>
                  <div className="banner-figcaption">
                    <div className="banner-figcaption__body">
                      <h5 className="banner-figcaption__title">
                        <a href="#">Secure Payment</a>
                      </h5>
                      <div className="banner-figcaption__text">
                        All Cards Accepted
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* banner section */}
        <div
          className="wb-section wb-section--section3"
          style={{ marginTop: "20px" }}
        >
          <div className="container">
            <div className="module-wrapper staticBanner staticBanner--blockBanner1 wow fadeIn">
              <div
                className="block-content clearfix d-flex flex-row"
                style={{ display: "flex", justifyContent: "center" }}
              >
                {bannerList.slice(0, 2).map((banner) => (
                  <div key={banner.id} className="banner-figures">
                    <div className="banner-figure">
                      <a href={banner.product_url} aria-label={banner.alt}>
                        <img
                          src={banner.banner_image_path}
                          alt=""
                          title=""
                          className="lazyload img-fluid"
                          loading="lazy"
                        />
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <UniversalCard
          Heading={"BEST SELLER"}
          CardData={best_seller}
          refreshCardData={fetchAllProducts}
        />
        {/* popular products */}
        <div
          className="new-arrivals-container"
          style={{ width: "95%", margin: "auto", marginTop: "20px" }}
        >
          <h2
            className="section-title section-title1"
            style={{ fontSize: "2.5vw", fontWeight: "900" }}
          >
            <span className="title-highlight">Popular</span> Products
          </h2>
          <PopularProoducts />
        </div>

        <div data-content-region="home_below_top_products"></div>
        <div data-content-region="home_below_new_products"></div>

        <div
          id="modal"
          className="modal"
          data-reveal
          data-prevent-quick-search-close
        >
          <button className="modal-close" type="button" title="Close">
            <span className="aria-description--hidden">Close</span>
            <span aria-hidden="true">&#215;</span>
          </button>
          <div className="modal-content"></div>
          <div className="loadingOverlay"></div>
        </div>

        <div
          id="alert-modal"
          className="modal modal--alert modal--small"
          data-reveal
          data-prevent-quick-search-close
        >
          <div className="alert-icon error-icon">
            <span className="icon-content">
              <span className="line line-left"></span>
              <span className="line line-right"></span>
            </span>
          </div>

          <div className="alert-icon warning-icon">
            <div className="icon-content">!</div>
          </div>

          <div className="modal-content"></div>

          <div className="button-container">
            <button type="button" className="confirm button" data-reveal-close>
              OK
            </button>
            <button type="button" className="cancel button" data-reveal-close>
              Cancel
            </button>
          </div>
        </div>
      </main>
      {/* <ScrollToTopButton/> */}
      <Footer />
    </div>
  );
};

export default Home;
